import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import { currencyConfig } from '../../../config/currency.config';
import { orderStatuses } from '../statuses';
import { OpenInNew } from '@mui/icons-material';

export default class PaymentOrdersPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'paymentOrders';
        this.Server = this.props.context.getState().server.paymentOrders;
        this.MenuDisplayType = 'menu';
        this.searchFields = [
            'uuid',
            'payerName',
            'pmOrder',
            'merchantOrder',
            'email',
            'phone',
            'description',
            'merchantTerminal.name'
        ];
        this.exportButton = true;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'uuid',
                    label: 'uuid',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'merchantTerminalId',
                    label: 'merchantTerminal',
                    alignRight: false,
                    cell: 'Select',
                    object: 'merchantTerminal',
                    show: 'name+merchantTerminalUuid',
                    from: 'publicMerchantTerminals',
                    filterCell: 'Context',
                    filterBy: 'publicMerchantTerminals',
                    displayGrid: true
                },
                {
                    id: 'pmOrder',
                    label: 'pmOrder',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'merchantOrder',
                    label: 'merchantOrder',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'status',
                    label: 'status',
                    alignRight: false,
                    cell: 'State',
                    items: Object.keys(orderStatuses),
                    displayGrid: true,
                    filterCell: 'Items',
                    translate: 'enums'
                },
                {
                    id: 'amount',
                    label: 'amount',
                    alignRight: false,
                    cell: 'Amount',
                    displayGrid: true
                },
                {
                    id: 'description',
                    label: 'description',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'internalStateDescription',
                    label: 'internalStateDescription',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'lifeTime',
                    label: 'lifeTime',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'email',
                    label: 'email',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'phone',
                    label: 'phone',
                    alignRight: false,
                    cell: 'Phone',
                    displayGrid: true
                },
                {
                    id: 'ip',
                    label: 'ip',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'ipMerchant',
                    label: 'ipMerchant',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'successUrl',
                    label: 'successUrl',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'errorUrl',
                    label: 'errorUrl',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'callbackUrl',
                    label: 'callbackUrl',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'comment',
                    label: 'comment',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableSort: true
                },
                {
                    id: 'createdType',
                    label: 'createdType',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'backUrl',
                    label: 'backUrl',
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'postbackUrl',
                    label: 'postbackUrl',
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'isRecurrent',
                    label: 'isRecurrent',
                    alignRight: false,
                    cell: 'Checkbox',
                    type: 'boolean',
                    displayGrid: true
                },
                {
                    id: 'recurrentId',
                    label: 'recurrentId',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'payerName',
                    label: 'payerName',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'pan',
                    label: 'pan',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'statusDesc',
                    label: 'statusDesc',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'currency',
                    label: 'currency',
                    alignRight: false,
                    cell: 'Items',
                    type: 'currency',
                    noTranslate: true,
                    items: Object.keys(currencyConfig),
                    displayGrid: true
                },
                {
                    id: 'statusJson',
                    label: 'statusJson',
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'Json'
                },
                // {
                //     id: 'action',
                //     label: 'action',
                //     disableEditor: true,
                //     displayDialogDetails: true,
                //     details: 'TextDetails'
                // },
                {
                    id: 'dateCreatedModified',
                    elements: ['dateCreated', 'dateModified'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'dateCreated',
                },
                // {
                //     id: 'dateModified',
                //     label: 'dateModified',
                //     alignRight: false,
                //     cell: 'Date',
                //     disableEditor: true,
                //     displayGrid: true
                // }
            ];

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
    renderCustomMenuItems() {
        return [
            <MenuItem
                key="showDetails"
                onClick={(event) => this.handleShowDialogDetails(event)}
            >
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>,
            <MenuItem
                key="goToP2pInstances"
                onClick={(event) => this.handleGoToLinkedGrid(event, 'p2p-instances', 'merchantOrder')}
            >
                <OpenInNew sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.goToP2pInstances')}
            </MenuItem>,
            <MenuItem
                key="goToPaymentInstances"
                onClick={(event) => this.handleGoToLinkedGrid(event, 'payment-instances', 'merchantOrder')}
            >
                <OpenInNew sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.goToPaymentInstances')}
            </MenuItem>,
        ];
    }
}
